import React from "react";
import LanguageAssessmentComponent from "./LanguageAssessmentComponent";
import { CONST } from "../../../_config";

export default function LogoAssessmentHeader(props) {
  const { surveyScreenData, template, details, logout, handleReport, LanguageList, handleLanguage, surveyLanguageName } = props;

  let [scrollPosition, HandlescrollPosition] = React.useState(0);

  let lastKnownScrollPosition = 0;
  document.addEventListener("scroll", () => {
    lastKnownScrollPosition = window.scrollY;
    HandlescrollPosition(lastKnownScrollPosition);
  });

  // console.log("surveyScreenData",surveyScreenData)
  let headerColor =
    surveyScreenData && surveyScreenData.headerColor
      ? surveyScreenData.headerColor
      : "";

  console.log("LanguageList---->", LanguageList);

  return (
    <>
      {(scrollPosition < 50 && template === "v4") || true ? (
        <div className="  w-full  bg-white border-b  h-20 flex items-center ">
          <div className="flex justify-between  xl:w-11/12 w-full mx-auto xl:px-0 px-4 items-center ">
            <img
              src={CONST.IMAGES_URL+"/tp_talent_plus_logo.svg"} 
              className="md:w-36 w-28 bg-cover"
            />
            

              {LanguageList && LanguageList.length>0?
                LanguageList.length>0?
        
                <div className="flex md:space-x-4 space-x-2  items-center cursor-pointer relative group ">
                <LanguageAssessmentComponent langList={LanguageList} handleLanguage={handleLanguage} surveyLanguageName={surveyLanguageName} template={'v4'}/>
                </div>
                :
                <div className=""/>
              :<div className=""/>}


              



            <div className="flex md:space-x-4 space-x-2  items-center cursor-pointer relative group ">
              <span className="material-symbols-outlined text-[3rem] text-[#2196f3] ">
                account_circle
              </span>
              <p className="md:text-base text-sm font-semibold text-[#3D405B] ">
                {details && details.name ? details.name : "User"}
              </p>

              <div className="bg-white  rounded-lg shadow-xl absolute top-12 right-0 border overflow-hidden py-4 w-36 group-hover:block hidden">
                <button
                  onClick={() => handleReport()}
                  className="md:text-base text-sm font-semibold text-[#3D405B] flex items-center cursor-pointer hover:bg-slate-100 px-4 py-2 w-full "
                >
                  <span class="material-symbols-outlined mr-2">lab_profile</span>{" "}
                  {"Report"}
                </button>

                <button
                  onClick={() => logout()}
                  className="md:text-base  text-sm font-semibold text-red-500 flex items-center cursor-pointer hover:bg-slate-100 px-4 py-2 w-full "
                >
                  <span class="material-symbols-outlined mr-2 text-red-500">logout</span>{" "}
                  {"Logout"}
                </button>
              </div>

              {/* <span className="material-symbols-outlined text-[#2196f3]">
              arrow_drop_down
              </span> */}
            </div>

            {/* <div className="">
              {surveyScreenData && surveyScreenData.logo2 ? (
                <img
                  alt="newlogo2"
                  style={{ height: "70px" }}
                  src={surveyScreenData.logo2}
                />
              ) : null}
            </div>

            <div />

            <div className="">
              {surveyScreenData && surveyScreenData.logo ? (
                <img
                  alt="newlogo"
                  style={{ height: "70px" }}
                  src={surveyScreenData.logo}
                />
              ) : null}
            </div> */}
          </div>
        </div>
      ) : null}
    </>
  );
}
